<template>
  <vs-tabs
    :position="isSmallerScreen ? 'top' : 'left'"
    class="tabs-shadow-none"
  >
    <vs-tab icon-pack="feather" icon="icon-user-check" :label="!isSmallerScreen ? 'Verificação em Duas Etapas' : ''">
      <template #label>
        {{ !isSmallerScreen ? 'Verificação em Duas Etapas' : verifyActivity ? 'Ativada' : 'Desativada' }}
      </template>
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <vs-alert title="Atenção!" active="true" color="warning" icon="warning" style="height: 130px;" :style="isSmallerScreen ? { height: '170px', display: 'block', fontSize: '20px' } : {}">
            Muita <strong>atenção</strong> agora a verificação em duas etapas é obrigatória no <strong>Backoffice.</strong>

            A verificação em duas etapas é um tipo de verificação extra, que integra sua conta do backoffice ao app do Google Authenticator, mantendo os acessos mais seguros.
          </vs-alert>
          <div class="flex flex-wrap justify-between my-5">
          <div class="flex flex-wrap items-center justify-end">
            <vs-button
              class="ml-auto mt-2"
              :color="buttonColor"
              type="filled"
              @click.prevent="saveSettings"
            >{{ buttonText }}</vs-button>
          </div>
        </div>
        
        <vs-popup
        title="Atenção! Faça corretamente a autenticação!"
        :active.sync="showModal"
        class="sizePopup"
        >
        <TwoFactorAuthSetup @showModal="closePopup" :verifyActivity="verifyActivity" @backToQrCode="showModal = true"></TwoFactorAuthSetup>
        </vs-popup>
      </div>
    </vs-tab>
  </vs-tabs>
</template>


<script>
import TwoFactorAuthSetup from "@/components/twoFactor/TwoFactorAuthSetup.vue"

export default {
  name: 'user-settings',
components: {
  TwoFactorAuthSetup
},
data() {
  return {
    verifyActivity: false,
    showModal: false,
    close: false,
    twoFactorEnabled: false,
  };
},
computed: {
  isSmallerScreen() {
    return this.$store.state.windowWidth <= 836;
  },
  buttonText() {
      return this.twoFactorEnabled ? "Alterar dois fatores" : "Ative agora os dois fatores";
  },
  buttonColor() {
      return this.twoFactorEnabled ? "success" : "primary";
  },
},
methods: {
  async getUsers() {
      try {
        await this.$store.dispatch('getAllUsers')
        const response = this.$store.state.users.users
        const email = localStorage.getItem('email')
        const usersFilteredByEmail = response.filter(user => user.email === email);
        this.twoFactorEnabled = usersFilteredByEmail[0].twofactor_activity
        return response
      } catch (Exception) {
        return []
      }
  },
  async saveSettings() {
    this.verifyActivity = true
    this.$vs.notify({
      title: 'Autenticação em 2 Fatores',
      text: 'Ação realizada com sucesso',
      iconPack: 'feather',
      icon: 'icon-alert-circle',
      color: 'success',
    });
    const email = localStorage.getItem('email');
    const response = await this.getUsers()
    const result = response.filter(item => item.email === email)
    const role = result[0].role.display_name
    const id = result[0].id
    const token = localStorage.getItem('token')
      if (this.verifyActivity !== true) {
        this.$vs.loading()
            await this.$store.dispatch('activityTwoFactor', {id: id, token: token, alterObject: {"twofactor_activity": this.verifyActivity, "role": role, "email": email}})
            localStorage.setItem('twoFactor', String(this.verifyActivity));
      }
      if(this.verifyActivity){
          setTimeout(() => {
            this.showModal = true
          }, 500);
      }
  },
  closePopup(value){
    this.showModal = value
  }
},
created() {
  const storedValue = localStorage.getItem('twoFactor');
  const parsedValue = storedValue === 'true';
  this.verifyActivity = parsedValue
},
async mounted() {
    await this.getUsers();
    this.closePopup()
    
},
beforeRouteLeave(to, from, next) {
    this.showModal = false;
    this.$events.fire('closePopUpSetting');
    setTimeout( ()=> {
      next();
    }, 10);
},
};
</script>
